import React from 'react'
import { AudioPlayer } from '@barstoolsports/react-audio-player'
import { sendEvent } from 'lib/ga'

const PodcastPlayer = ({ story }) => {
  const {
    title: trackTitle,
    show,
    episode_url: trackUrl,
    created_at: createdAt,
    duration
  } = story.post_type_meta.podcast

  const handleEvent = (event) =>
    sendEvent('Barstool Audio Player', event, {
      label: `${story.id} | ${trackTitle}`
    })

  const apProps = {
    trackTitle,
    trackUrl,
    createdAt,
    cover: show.image,
    artist: show.title,
    duration,
    menu: false,
    onPlay: () => handleEvent('Play'),
    onPause: () => handleEvent('Pause'),
    onAudioSpeedChange: () => handleEvent('Audio Speed Change'),
    onBack15: () => handleEvent('Back :15'),
    onSkip30: () => handleEvent('Skip :30')
  }

  return (
    <>
      <div className='podcastPlayer'>
        <AudioPlayer {...apProps} />
      </div>
      <style jsx>{`
        .podcastPlayer {
          margin-bottom: 25px;
        }
      `}</style>
    </>
  )
}

export default PodcastPlayer
